import { getHomeUrl } from 'services/navigation';

export const homeBreadcrumbItem = {
  title: 'Главная',
  url: getHomeUrl(),
};
